import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
      <div class="poem">
        <p class="poem-block mb-3">
          Vi kresku sana en ador’<br/>
          Amata kaj sukcesa.<br/>
          De via vivo la auxror’<br/>
          Okazu belpromesa.
        </p>

        <p class="poem-block mb-3">
          Por la gepatroj estu gxoj’<br/>
          Kaj ankaux por avino.<br/>
          Sur la felicxa viva voj’<br/>
          Dorlotu vin destino.
        </p>
      </div>
    `
  )
}

const itemName = {
  esp: 'Al la nepo'
}
const itemDate = {
  esp: '15 novembro 2006'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemDate: itemDate.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}


export default item;